import { createUseStyles } from "react-jss";
import { colors } from "../../../constants/colors";
import { breakpoints } from "../../../constants/breakpoints";

const styles = createUseStyles({
  travelCreditsTab: {
    margin: "32px 0px",
    border: "1px solid " + colors.lightGrey,
    boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)",
    borderRadius: "12px",
    overflow: "hidden"
  },
  travelCreditsHeader: {
    display: "flex",
    padding: "20px 24px 0",
    justifyContent: "space-between",
    alignItems: "flex-start",
    flexWrap: "nowrap",
    gap: "16px",
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      flexDirection: "column"
    },
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      flexWrap: "wrap",
    },
    "& > div:first-child": {
      maxWidth: "60%",
      [`@media (max-width: ${breakpoints.sm}px)`]: {
        maxWidth: "100%",
      },
    },
  },
  title: {
    color: colors.lightBlack,
    fontWeight: 600,
    fontSize: "18px",
    lineHeight: "28px",
    margin: "0px"
  },
  subtitle: {
    color: colors.mediumGrey,
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "20px",
    marginTop: "4px",
    marginBottom: 0
  },
  buttonContainer:{
    display: "flex",
    height: "min-content",
    alignSelf: "start",
    whiteSpace: "nowrap"
  },
  button: {
    height: "40px",
    alignItems: "center"
  },
  divider: {
    width: "100%",
    color: colors.lightGrey,
    opacity: 2,
    margin: "20px 0px 0px"
  },
  filters: {
    display: "flex",
    justifyContent: "space-between",
    padding: "12px 16px",
    gap: "12px",
    flexDirection: "column",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column"
    },
    [`@media (max-width: ${breakpoints.xs}px)`]: {
      padding: "8px"
    }
  },
  tabs:{
    display:"flex"
  },
  tab: {
    fontWeight: 600,
    fontSize: "14px",
    lineHeight: "20px",
    width: "fit-content",
    display: "inline-block",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      padding: "10px 8px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      padding: "8px"
    }
  },
  active: {
    backgroundColor: colors.brightBlue,
    pointerEvents: "none"
  },
  availableButton: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
    borderRight: "none",
    "&:hover": {
      borderRight: "none"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    }
  },
  usedButton: {
    borderRadius: 0,
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    }
  },
  expiredButton: {
    borderLeft: "none",
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
    "&:hover": {
      borderLeft: "none"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%"
    }
  },
  icon: {
    marginRight: "8px"
  },
  expirationFilter: {
    minWidth: "200px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "100%",
    }
  },
  inputWrapperStyling: {
    maxWidth: "360px",
    width: "100%",
    height: "fit-content",
    "& input": {
      padding: "0 42px 0 42px"
    },
    "& svg": {
      marginTop: "auto",
      marginBottom: "auto",
      top: 0,
      bottom: 0,
      height: "20px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      maxWidth: "unset"
    }
  },
  clearBtn: {
    position: "absolute",
    right: 0,
    cursor: "pointer"
  },
  clearBtnIcon: {
    top: "8px",
    right: "16px",
    position: "absolute",
    height: "20px",
    width: "20px",
    "& path": {
      stroke: colors.inactiveGrey
    }
  },
  settingsButton: {
    marginRight: "12px",
  },
  buttonsDiv: {
    display: "flex",
    alignSelf: "center"
  },
  confirmActionContainer: {
    margin: "12px 0px 4px 0px",
    "& p": {
      fontSize: "14px",
      fontWeight: 400,
      lineHeight: "20px",
      color: colors.mediumGrey,
      marginBottom: "12px",
      textAlign: "justify"
    },
     "& span": {
      fontSize: "14px",
      fontWeight: 600,
      lineHeight: "20px",
      color: colors.mediumGrey
    }
  },
  searchContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "12px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  subheader:{
    display: "flex",
    padding:"14px 24px",
    alignItems: "center",
    gap: "16px",
    backgroundColor: colors.primary50Blue,
    justifyContent: "space-between",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      flexDirection: "column",
      alignItems: "flex-start"
    }
  },
  blueText: {
    marginBottom: "0px",
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    color: colors.darkBlue,
    display: "flex",
    padding: "2px 10px 2px 8px",
    alignItems: "center",
    gap: "6px",
    borderRadius: "16px",
    backgroundColor: colors.primary50Blue,
    mixBlendMode: "multiply",
  },
  blueDot: {
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    backgroundColor: colors.darkBlue,
    display: "inline-block",
    flexShrink: 0,
  },
  blueIcon: {
    width: "16px",
    height: "16px",
    flexShrink: 0,
    "& path": {
      stroke: colors.darkBlue
    }
  },
  subheaderTitle: {
    marginBottom: "0px",
    fontSize: "16px",
    fontWeight: 600,
    lineHeight: "24px",
    color: colors.lightBlack,
  },
  subheaderDesc: {
    extend: "blueText",
    color: colors.mediumGrey,
    fontWeight: 400
  },
  subheaderDivider: {
    extend: "divider",
    margin: "0px"
  },
  expiryBanner: {
    display: "flex",
    padding:"8px 20px",
    alignItems: "center",
    gap: "10px",
    backgroundColor: colors.bannerYellow,
    marginRight: "16px",
    marginLeft: "16px",
    marginTop: "20px",
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      alignItems: "flex-start"
    },
    "& p":{
      marginBottom: "0px",
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: colors.black,
    }
  },
  gridActionsButtons: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    "& button": {
      height: "32px",
      padding: "0px 12px"
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      alignItems: "flex-start",
      flexDirection: "column"
    },
  },
  alertIcon: {
    "& svg": {
      width: "20px",
      height: "20px",
      marginBottom: "4px"
    },
  },
  travelCreditsTitleContainer:{
    display: "flex",
    alignItems: "center",
    gap: "12px",
    [`@media (max-width: ${breakpoints.lg}px)`]: {
      alignItems: "flex-start",
      flexDirection: "column"
    },
  },
  infoPopover:{
    "& .popover-arrow::before": {
      borderRightColor: colors.lightGrey,
    },
    maxWidth: "365px !important",
    borderColor: colors.lightGrey,
    boxShadow: "0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)",
  },
  infoPopoverDiv:{
    display:"flex",
    flexDirection:"column",
    alignItems:"start",
    backgroundColor: colors.white,
    padding: "12px",
    borderRadius: 8,
    color: colors.black,
    width:"360px !important"
  },
});

export default styles;

export const expirationDateSelect = theme =>({
  option: (base, state) =>({
    ...base,
    color: state.isSelected ? colors.darkBlue : colors.mediumGrey,
    fontSize: "14px",
    fontWeight: state.isSelected ? 600 : 500,
    lineHeight: "20px",
    img: {
      display: "none",
    },
    backgroundColor: state.isSelected ? colors.primary50Blue : colors.white,
  }),
  singleValue: (base, state) => ({
    ...base,
    color: colors.mediumGrey,
    fontSize: "14px",
    fontWeight: 500,
    lineHeight: "20px",
    padding: "0px"
  }),
  control:(base, state) => ({
    ...base,
    border: "1px solid " + colors.lightGrey,
    borderRadius: "8px",
    boxShadow: "none",
    borderColor: colors.lightGrey,
    "&:hover": {
      borderColor: colors.lightGrey,
    },
  }),
  dropdownIndicator: (base) => ({
    ...base,
    paddingRight: "14px",
  }),
  valueContainer: base => ({
    ...base,
    padding: "0px 0px 0px 14px"
  })
})
